import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
//import { environment } from '../../environments/environment';
import { environment } from 'src/app/_services/config.service'
import { parseTemplate } from '@angular/compiler';
import { promise } from 'selenium-webdriver';

@Injectable()
export class VASProductMgmtService {




  BASE_URL = environment.BASE_URL + "/vasprodmgmt";
  BASE_URL2 = environment.BASE_URL + "/productmgmtservice/";
  BUCKET_URL = environment.S3_BUCKEt_URL;
  prodCode: String;
  sessionId: String;
  patnerId: String;
  usrRefId: String;



  constructor(private http: HttpClient) {
  }
  //added app token for top broker api
  getTopBrokerList(nVasUserId, partnerAppId, appToken) {
    // let headers = new Headers();
    // this.createVASOrgHeader(headers);
    // let headers: Headers = new Headers();
    //  headers.append('Accept', 'application/json');
    //     headers.append('zumo-api-version', '2.0.0');
    // Http Options
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        // 'tenantIdHeader': '0'
      })
    }
    if (nVasUserId === null || nVasUserId === 'undefined') {
      if (partnerAppId != null && partnerAppId != "") {
        return this.http.get(this.BASE_URL + '/topBroker?sLoginId=' + '&partnerAppId=' + partnerAppId + '&sAppToken=' + appToken, httpOptions);
      } else {
        return this.http.get(this.BASE_URL + '/topBroker?sLoginId=' + '&partnerAppId=' + '&sAppToken=' + appToken, httpOptions);
      }
    } else {
      if (partnerAppId != null && partnerAppId != "") {
        return this.http.get(this.BASE_URL + '/topBroker?sLoginId=' + nVasUserId
          + '&partnerAppId=' + partnerAppId + '&sAppToken=' + appToken, httpOptions);
      } else {
        return this.http.get(this.BASE_URL + '/topBroker?sLoginId=' + nVasUserId + '&partnerAppId=' + '&sAppToken=' + appToken, httpOptions);
      }
    }
  }

  createVASOrgHeader(headers: Headers) {
    headers.set('tenantIdHeader', '0');
  }

  getVasPortalRedirect(entity: any): any {
    return this.http.post(this.BASE_URL + '/vas/portal/redirect', entity);
  }

  getBrokerPortalRedirect(sInitiatorAppToken, sPartnerAppId, nRequestType, sProductCode, sSession, sThirdPartyId, oEchoBackObject): any {

    if (nRequestType == 3) {
      if (sPartnerAppId == null || sPartnerAppId == "") {
        this.patnerId = null;

      } else {
        this.patnerId = sPartnerAppId;
      }



      return this.http.get(this.BASE_URL + '/broker/portal/redirect?sInitiatorAppToken=' + sInitiatorAppToken
        + '&sPartnerAppId=' + this.patnerId
        + '&sProductCode=' + sProductCode

        + '&nRequestType=' + nRequestType
        + '&sSession=' + sSession
        + '&sThirdPartyId=' + sThirdPartyId
        + '&oEchoBackObject=' + oEchoBackObject
      );
    } else {


      if (sProductCode == null || sProductCode == "") {
        this.prodCode = null;

      } else {
        this.prodCode = sProductCode;
      }

      if (sSession == null || sSession == "") {
        this.sessionId = null;

      } else {
        this.sessionId = sSession;
      }



      return this.http.get(this.BASE_URL + '/broker/portal/redirect?sInitiatorAppToken=' + sInitiatorAppToken
        + '&sPartnerAppId=' + sPartnerAppId
        + '&sProductCode=' + this.prodCode

        + '&nRequestType=' + nRequestType
        + '&sSession=' + this.sessionId
        + '&sThirdPartyId=' + sThirdPartyId
        + '&oEchoBackObject=' + oEchoBackObject
      );
    }
  }

  getBrokerList(nVasUserId, partnerAppId) {
    // let headers = new Headers();
    // this.createVASOrgHeader(headers);

    // let headers: Headers = new Headers();
    //  headers.append('Accept', 'application/json');
    //     headers.append('zumo-api-version', '2.0.0');
    // Http Options
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        // 'tenantIdHeader': '0'
      })
    }
    if (nVasUserId === null || nVasUserId === 'undefined') {
      if (partnerAppId != null && partnerAppId != "") {
        return this.http.get(this.BASE_URL + '/getBroker?sLoginId=' + '&partnerAppId=' + partnerAppId, httpOptions);
      } else {
        return this.http.get(this.BASE_URL + '/getBroker?sLoginId=' + '&partnerAppId=', httpOptions);
      }
    } else {
      if (partnerAppId != null && partnerAppId != "") {
        return this.http.get(this.BASE_URL + '/getBroker?sLoginId=' + nVasUserId
          + '&partnerAppId=' + partnerAppId, httpOptions);
      } else {
        return this.http.get(this.BASE_URL + '/getBroker?sLoginId=' + nVasUserId + '&partnerAppId=', httpOptions);
      }
    }
  }


  postValidateUser(entity: any): any {

    return this.http.post(this.BASE_URL + '/validate/thirdparty/user/product', entity);
  }


  getVasPortalCallback(authorization, sStatusCode, sStatusMessage, sRestSession) {
    return this.http.get(this.BASE_URL + '/vas/portal/callback?authorization=' + authorization + '&sStatusCode=' + sStatusCode + '&sStatusMessage=' + sStatusMessage + "&sRestSession=" + sRestSession);
  }

  authenticateUser(entity: any): any {
    return this.http.post(this.BASE_URL + '/authenticate', entity);
  }

  OtpVerifiction(entity: any): any {
    return this.http.post(this.BASE_URL + '/verifiy/user/otp', entity);
  }

  userAppMapping(entity: any): any {
    return this.http.post(this.BASE_URL + '/thirdparty/user/mapping', entity);
  }

  sourceAppRedirect(entity: any): any {
    return this.http.post(this.BASE_URL + '/thirdparty/source/redirect', entity);
  }



  ValidateOtp(entity: any): any {

    return this.http.post(this.BASE_URL + '/odin/connector/existing/User/validate', entity);
  }

  checkVasUserId(tpid, partnerId, appToken, productCode, nRequestType, oEchoBackObject): any {
    if (tpid === null || tpid === undefined) {

      return this.http.get(this.BASE_URL + '/checkVasUser?sThirdPartyId=' + tpid + "&partnerAppId=" + partnerId + "&sAppToken=" + appToken + "&sProductCode=" + productCode + "&nRequestType=" + nRequestType + "&oEchoBackObject=" + oEchoBackObject);

      //return this.http.get(this.BASE_URL + '/checkVasUser?sThirdPartyId');
    } else if (tpid != undefined && partnerId == "" || partnerId == null) {
      return this.http.get(this.BASE_URL + '/checkVasUser?sThirdPartyId=' + tpid + "&partnerAppId=" + partnerId + "&sAppToken=" + appToken + "&sProductCode=" + productCode + "&nRequestType=" + nRequestType + "&oEchoBackObject=" + oEchoBackObject);

    } else {
      return this.http.get(this.BASE_URL + '/checkVasUser?sThirdPartyId=' + tpid + "&partnerAppId=" + partnerId + "&sAppToken=" + appToken + "&sProductCode=" + productCode + "&nRequestType=" + nRequestType + "&oEchoBackObject=" + oEchoBackObject);
    }
  }

  getBrokerPlanDetails(nPatnerId: any): any {
    console.log("partnerId " + nPatnerId)
    return this.http.get(this.BASE_URL2 + 'brokerPlan/planDetails?nPatnerId=' + nPatnerId)

    //return this.http.get("http://localhost:8222/"+ 'brokerPlan/planDetails?nPatnerId=' + nPatnerId);

  }
  // localhost:8222/brokerPlan/planDetails?nPatnerId=0DD0F8

  getBrokerSubscriptionCount(nOrgId: any): any {
    return this.http.get(this.BASE_URL2 + 'brokerPlan/getSubscriptionCount/' + nOrgId);
    //return this.http.get("http://localhost:8222/" + 'brokerPlan/getSubscriptionCount/'+nOrgId);
  }

  saveBrokerSubscriptionPlan(userSubscriptionDetails: any): any {
      return this.http.post(this.BASE_URL2 + 'brokerPlan/saveUserSubscriptionDetails', userSubscriptionDetails);
   //return this.http.post("http://172.25.94.195:8223/" + 'brokerPlan/saveUserSubscriptionDetails', userSubscriptionDetails);
  }

  getUserSubscriptionDetails(sPatnerId: any, sTradingUserId: any): any {
    return this.http.get(this.BASE_URL2 + 'brokerPlan/getSubscriptionDetails/' + sPatnerId + '/' + sTradingUserId);
  }

  reconfigureSubscription(userSubscriptionDetails: any): any {
      return this.http.post(this.BASE_URL2 + 'brokerPlan/reconfigureSubscription', userSubscriptionDetails);
   // return this.http.post("http://172.25.90.195:8223/" + 'brokerPlan/reconfigureSubscription', userSubscriptionDetails);

  }

  renewSubscriptionPlan(userSubscriptionDetails: any): any {
    return this.http.post(this.BASE_URL2 + 'brokerPlan/renewSubscription', userSubscriptionDetails);
  }

  deActivateSubscriptionPlan(userSubscriptionDetails: any): any {
    return this.http.post(this.BASE_URL2 + 'brokerPlan/deActivateSubscription', userSubscriptionDetails);
  }

  deleteSubscriptionPlan(userSubscriptionDetails: any): any {
    return this.http.post(this.BASE_URL2 + 'brokerPlan/deleteSubscription', userSubscriptionDetails);
  }

  getPartnerID(orgId) {
    //console.log(deleteeventIdData)
    return this.http.get(this.BASE_URL2 + 'brokerPlan/getptnerid/' + orgId);
  }


  getAllPublisher(sPatnerId: any): any {
    let form = {
      "sPatnerId": sPatnerId,
      "nOrgId": null
    }
    //return this.http.get(this.BASE_URL2 + '/172.25.91.177:8122/productservice/getPublisher' + sPatnerId);
    //return this.http.post("http://172.25.91.177:8223" + '/getBrokerPublisherMapping', form);
    return this.http.post(this.BASE_URL2 + 'getBrokerPublisherMapping', form);
  }


  getUserSubscriptionStatus(payload: any): any {
    //return this.http.post("http://172.25.91.177:8122" + '/productservice/getSubscriptionDetails', payload);
    return this.http.post(this.BASE_URL2 + 'getSubscriptionDetails', payload);
  }


  getBrokerPublisherSubscriberCount(nOrgID: any): any {


    //let nOrgId=id;
    //   let nOrgId = nOrgID;
    //return this.http.get(this.BASE_URL2 + '/172.25.91.177:8122/productservice/getPublisher' + sPatnerId);
    //return this.http.get("http://172.25.91.177:8122" + '/productservice/getSubscriberCount?nOrgId=' + nOrgID)
    return this.http.get(this.BASE_URL2 + 'getSubscriberCount/' + nOrgID)

  }

  getAllPlans(sAppToken: any, sPartnerId: any): any {

    //return this.http.post("http://172.25.91.177:8122"+'/productservice/getPublisherPlanDetails',payload);
    // return this.http.post("http://172.25.91.177:8223" + '/getPublisherPlanDetails', payload);
    return this.http.get(this.BASE_URL2 + 'getPublisherPlan/' + sAppToken + "/" + sPartnerId);
  }

  async checkB2CLicense(nOrgID: any) {
    //return this.http.get("http://172.25.91.177:8122"+'/productservice/getLicenceDetails?nOrgID='+nOrgID);
    //return this.http.get("http://172.25.91.177:8223" + '/getLicenceDetails?nOrgID=' + nOrgID);

    let data = await this.http.get(this.BASE_URL2 + 'getLicenceDetails/' + nOrgID).toPromise();
    return data
    // return this.http.get("http://localhost:8222/"+'getLicenceDetails/'+nOrgID);
  }


  getodinConnectorPublisherURL(payload: any): any {

    console.log(payload + "value of payload");
    // return this.http.post("http://172.25.92.38:8223"+'/marketplacePublisherURL', payload);
    return this.http.post(this.BASE_URL + '/marketplacePublisherURL', payload);
  }


  getSubscriptionDetailsMarketPlace(payload: any): any {

    return this.http.post(this.BASE_URL2 + 'getSubscriptionDetails', payload);
  }


  writeAppLog(href: any): any {
    let payload = {
      href: href
    }
    //return this.http.post("http://172.25.105.121:8223" + '/writeAppLog', payload);

    return this.http.post(this.BASE_URL + '/writeAppLog', payload);

  }

  createVasUser(payload: any): any {
    return this.http.post(this.BASE_URL + '/createVasUser', payload);
    // return this.http.post("http://172.25.105.121:8223" + '/createVasUser', payload);
  }

  getCategoryTypes() {
    let sType = "category";
    return this.http.get(this.BASE_URL + '/getEntityType?sType=' + sType);
    //  return this.http.get("http://172.25.105.121:8223" + '/getEntityType?sType='+ sType);
  }

  //BT-144069 Name:- Gaurav Dwivedi date:- 18/09/2024 B2C subscription API modification encryption decryprion technical finding with developmnet
  checkExistingUserSubscription(): any {
    return this.http.get(this.BASE_URL2 + 'brokerPlan/checkExistingUserSubscription');
    // return this.http.post("http://172.25.91.177:8223" + '/brokerPlan/checkExistingUserSubscription', userSubscriptionDetails);
  }

  async getConnectorPublisherUrl(payload: any): Promise<any> {
    try {
      let data = await this.http.post(this.BASE_URL + '/marketplacePublisherURL', payload).toPromise();
      return data
    } catch (error) {
      console.log("error:", error)
    }

  }

  async getAllMarketplacePublisher(sPatnerId: any): Promise<any> {
    let form = {
      "sPatnerId": sPatnerId,
      "nOrgId": null
    }
    // return this.http.post("http://172.25.91.177:8122" + '/productservice/getBrokerPublisherMapping', form);
    try {
      let data = await this.http.post(this.BASE_URL2 + 'getBrokerPublisherMapping', form).toPromise();
      console.log("data=", data);

      return data
    } catch (error) {
      console.log("error:", error)
    }

  }

  async getPtnrID(orgId: any): Promise<any> {
    //console.log(deleteeventIdData)
    try {
      let data = await this.http.get(this.BASE_URL2 + 'brokerPlan/getptnerid/' + orgId).toPromise();
      return data;
    }
    catch (error) {
      console.log("error:", error)
    }

  }

  async getPubS3Details(orgId): Promise<any> {
    try {
      let data = await this.http.get(this.BUCKET_URL + orgId + '/publisherDetails.json').toPromise();
      return data;
    } catch (error) {
      console.log("error:", error)
    }

  }

  //start jay patil  Date:-07March2025 BT-155379 Fixed prod issue for ticket number 162740
  async getSession(payload: any): Promise<any> {
    try {
      let data = await this.http.post(this.BASE_URL + '/B2CPublisherURL', payload).toPromise();
      //let data = await this.http.post('http://172.25.91.177:8223' + '/B2CPublisherURL', payload).toPromise();
      return data
    } catch (error) {
      console.log("error:", error)
    }

  }

  //end jay patil  Date:-07March2025 BT-155379 Fixed prod issue for ticket number 162740

  //start jay patil Date:-30April2025 BT-157623 Require redirect investment URL Query pram in encrypted mode in Marketplace Publisher
  async getOdinConnectorEncPublisherURL(payload: any): Promise<any> {
    try {
      let data = await this.http.post(this.BASE_URL + '/getMarketplaceEncPublisherURL', payload).toPromise();
      //let data = await this.http.post('http://172.25.91.177:8223' + '/getMarketplaceEncPublisherURL', payload).toPromise();
      return data
    } catch (error) {
      console.log("error:", error)
    }
  }
  //end jay patil Date:-30April2025 BT-157623 Require redirect investment URL Query pram in encrypted mode in Marketplace Publisher

  //start jay patil Date:-01April2026 OC-1665 Enable B2C clients to add a static IP address
  async updateIPAdress(payload: any): Promise<any> {
    try {
      let data = await this.http.post(this.BASE_URL + '/updateAlgoStatus', payload).toPromise();
      //let data = await this.http.post('http://172.25.94.195:8223' + '/updateAlgoStatus', payload).toPromise();
      return data
    } catch (error) {
      console.log("error:", error)
    }
  }
  //end jay patil Date:-01April2026 OC-1665 Enable B2C clients to add a static IP address
//start jay patil Date:-12June2026 
  async getOdinConnectorTPTokenPublisherURL(payload: any): Promise<any> {
    try {
      let data = await this.http.post(this.BASE_URL + '/odinConnectorPublisherURL', payload).toPromise();
      //let data = await this.http.post('http://172.25.91.177:8223' + '/getMarketplaceEncPublisherURL', payload).toPromise();
      return data
    } catch (error) {
      console.log("error:", error)
    }
  }
  //end jay patil Date:-12June2026

  //start Jay Patil 07/07/2026 OC-2157 Family account Static IP Validations- B2C User
  getTenantConfiguration(orgId: any): any {
    return this.http.get(this.BASE_URL2 + 'tenant/' + orgId);
  }
  //end jay Patil 07/07/2026 OC-2157 Family account Static IP Validations- B2C User

  //start Jay Patil Date 03Aug2026 OC-2177 Optimization on SSO B2B Login- ODIN Connector
  // Single call that replaces the four serialized round-trips the deep-integration screen used to
  // make: getPtnrID + getAllMarketplacePublisher + getPubS3Details + the publisher-URL family.
  // Those methods are intentionally left in place above - getOdinConnectorEncPublisherURL is
  // still used by mrktplace-broker-publisher-mapping.component.
  async getDeepIntegrationSession(payload: any): Promise<any> {
    try {
      let data = await this.http.post(this.BASE_URL + '/deepIntegration/initSession', payload).toPromise();
      return data
    } catch (error) {
      console.log("error:", error)
    }
  }
  //end Jay Patil Date 03Aug2026 OC-2177 Optimization on SSO B2B Login- ODIN Connector

}
